import { render, staticRenderFns } from "./StoryboardInstruction.vue?vue&type=template&id=25435eb4"
import script from "./StoryboardInstruction.vue?vue&type=script&lang=js"
export * from "./StoryboardInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports